module.exports = __webpack_public_path__ + "static/media/ranggi-1.546d47b1.jpg";